import React from 'react'
import { Button, ButtonGroup, Modal, Form } from 'react-bootstrap'
import { FaUpload, FaFileDownload, FaPenAlt } from 'react-icons/fa'
import { useStateAuthContext, useStateHostContext } from '../context';
import Swal from 'sweetalert2'

const AdminRekomendasiPajak = () => {
    const { STATE_AUTH } = useStateAuthContext();
    const { HOST } = useStateHostContext();
    const [data_rekomendasi, setData_rekomendasi] = React.useState([])
    const [loading, setLoading] = React.useState(false);
    const [showUploadModal, setShowUploadModal] = React.useState(false);

    const [data_opd, setData_opd] = React.useState([])
    const [opdTujuan, setOpdTujuan] = React.useState('')
    const [nomorSurat, setNomorSurat] = React.useState('');
    const [tglSurat, setTglSurat] = React.useState('');
    const [uploadFile, setUploadFile] = React.useState(null);

    const handleGetData = React.useCallback(async () => {
        setLoading(true);
        try {
            const param = {
                method: 'GET',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                }
            }
            const requ = await fetch(HOST + '/rekom_pajak/ambil_semua', param)
            const resp = await requ.json()

            if (requ.ok) {
                if (resp.s === true) {
                    setData_rekomendasi(resp.d)
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }, [HOST, STATE_AUTH])

    const handleGetDataOpd = React.useCallback(async () => {
        setLoading(true);
        try {
            const param = {
                method: 'GET',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                }
            }
            const requ = await fetch(HOST + '/opd/ambil', param)
            const resp = await requ.json()

            if (requ.ok) {
                if (resp.s === true) {
                    setData_opd(resp.d)
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }, [HOST, STATE_AUTH])


    React.useEffect(() => {
        handleGetData()
    }, [handleGetData])

    const validateFileType = (file) => {
        if (!file) return false;

        const allowedTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf'];
        const allowedExtensions = ['.doc', '.docx', '.pdf'];

        const fileType = file.type;
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

        return allowedTypes.includes(fileType) || allowedExtensions.includes(fileExtension);
    };

    const handleOpenUploadModal = () => {
        setNomorSurat('');
        setTglSurat('');
        setUploadFile(null);
        setShowUploadModal(true);
    };

    const handleCloseUploadModal = () => {
        setShowUploadModal(false);
        setNomorSurat('');
        setTglSurat('');
        setUploadFile(null);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (validateFileType(file)) {
                setUploadFile(file);
            } else {
                alert('Format file tidak didukung. Silakan upload file dengan format: DOC, DOCX, atau PDF');
                e.target.value = null; // Reset the file input
            }
        }
    };

    const handleDownloadTenplateSurat = async () => {
        // Show loading with progress
        Swal.fire({
            title: 'Memproses...',
            text: 'Sedang mengunduh dokumen, mohon tunggu sebentar',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {

            const req = await fetch(HOST + '/rekom_pajak/cetak', {
                method: 'GET',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                }
            });

            // Close the loading dialog
            Swal.close();

            if (!req.ok) {
                // Handle 4xx and 5xx errors
                if (req.status >= 400 && req.status < 600) {
                    let errorMessage = 'Gagal mengunduh dokumen';
                    try {
                        const errorResponse = await req.json();
                        errorMessage = errorResponse.m || errorResponse.message || errorMessage;
                    } catch (e) {
                        // If response is not JSON, use default error message
                        errorMessage = `Gagal mengunduh dokumen. Kode error: ${req.status}`;
                    }

                    Swal.fire({
                        title: 'Gagal!',
                        text: errorMessage,
                        icon: 'error',
                        confirmButtonColor: '#0d6efd'
                    });
                }
                return;
            }

            // --- Ambil nama file dari header ---
            const disposition = req.headers.get('Content-Disposition');
            let filename = "dokumen.docx";

            if (disposition) {
                // 1. Utamakan filename* (UTF-8)
                const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/);
                if (utfMatch && utfMatch[1]) {
                    filename = decodeURIComponent(utfMatch[1]);
                } else {
                    // 2. Fallback ke filename="....."
                    const normalMatch = disposition.match(/filename="([^"]+)"/);
                    if (normalMatch && normalMatch[1]) {
                        filename = normalMatch[1];
                    }
                }
            }

            // --- Proses download ---
            const blob = await req.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename; // ← nama dari server
            a.click();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            // Close the loading dialog if there's an error
            Swal.close();

            // Show error notification
            Swal.fire({
                title: 'Gagal!',
                text: 'Terjadi kesalahan saat mengunduh dokumen: ' + error.message,
                icon: 'error',
                confirmButtonColor: '#0d6efd'
            });
        }
    };

    const handleUploadSubmit = async (e) => {
        e.preventDefault();

        if (!uploadFile) {
            alert('Silakan pilih file terlebih dahulu');
            return;
        }

        if (!nomorSurat.trim()) {
            alert('Silakan masukkan Nomor Surat');
            return;
        }

        if (!tglSurat.trim()) {
            alert('Silakan masukan tanggal surat');
            return;
        }

        // Show loading indicator using SweetAlert
        Swal.fire({
            title: 'Membuat dokumen...',
            text: 'Mohon tunggu sebentar, dokumen sedang diproses',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const formData = new FormData();
            formData.append('OPD_TUJUAN', opdTujuan);
            formData.append('NOMOR_SURAT', nomorSurat);
            formData.append('TANGGAL_SURAT', tglSurat);
            formData.append('FILE_TEMPLATE', uploadFile);

            const param = {
                method: 'POST',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                },
                body: formData
            };

            const response = await fetch(HOST + '/rekom_pajak/buat', param);
            const result = await response.json();

            Swal.close(); // Close the loading dialog

            if (response.ok && result.s) {
                Swal.fire({
                    title: 'Berhasil!',
                    text: 'Dokumen berhasil diupload',
                    icon: 'success',
                    confirmButtonColor: '#0d6efd'
                });

                // Refresh data after successful upload
                handleGetData();
                handleCloseUploadModal();
            } else {
                Swal.fire({
                    title: 'Gagal!',
                    text: result.m || 'Gagal mengupload dokumen',
                    icon: 'error',
                    confirmButtonColor: '#0d6efd'
                });
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            Swal.close(); // Close the loading dialog
            Swal.fire({
                title: 'Error!',
                text: 'Terjadi kesalahan saat mengupload dokumen',
                icon: 'error',
                confirmButtonColor: '#0d6efd'
            });
        }
    };

    const handleDownloadSurat = async (path) => {
        try {
            const fd = new FormData();
            fd.append('FILE', path);
            const response = await fetch(HOST + '/rekom_pajak/download', {
                method: 'POST',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                },
                body: fd
            });
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = path;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    React.useEffect(() => {
        handleGetData();
        handleGetDataOpd();
    }, [handleGetDataOpd, handleGetData]);

    return (
        <main>
            <div className="container-fluid">

                <div className="row mt-3">
                    <div className="col-md-12">
                        <h3><strong><i className='fa fa-user-alt'></i>REKOMENDASI PAJAK</strong></h3>
                    </div>
                </div>
                <hr />
                <ButtonGroup>
                    <Button variant="info" className='me-2' size='sm' onClick={handleDownloadTenplateSurat}><FaFileDownload /> Download Template</Button>
                    <Button variant="primary" className='me-2' size='sm' onClick={handleOpenUploadModal}><FaUpload /> Buat Surat</Button>
                </ButtonGroup>
                <hr />
                <div className="row mt-2">
                    <div className="table-responsive">
                        {loading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <table className="tb-daftar-dinas mt-1">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>OPD Tujuan</th>
                                        <th>Nama Dokumen</th>
                                        <th>Nomor</th>
                                        <th>Tanggal</th>
                                        <th>Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data_rekomendasi.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.opd || '-'}</td>
                                            <td>{'Surat Rekomendasi Pajak'}</td>
                                            <td>{item.no_surat || '-'}</td>
                                            <td>{item.tgl_surat ? new Date(item.tgl_surat).toLocaleDateString('id-ID') : '-'}</td>
                                            <td>
                                                <Button variant="info" size="sm" onClick={() => handleDownloadSurat(item.nama_dokumen)}> <FaFileDownload /> Download</Button>
                                            </td>
                                        </tr>
                                    ))}
                                    {data_rekomendasi.length === 0 && (
                                        <tr>
                                            <td colSpan="6" className="text-center">Belum ada data rekomendasi pajak</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>

            {/* Upload Document Modal for Ketersediaan Menerima */}
            <Modal show={showUploadModal} onHide={handleCloseUploadModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Buat Surat Rekomendasi</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleUploadSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>OPD Tujuan</Form.Label>
                            <Form.Select
                                value={opdTujuan}
                                onChange={(e) => setOpdTujuan(e.target.value)}
                                required
                            >
                                <option value="">Pilih OPD Tujuan</option>
                                {data_opd.map((item) => (
                                    <option key={item.id_opd} value={item.id}>
                                        {item.opd}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Nomor Surat</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Masukkan nomor surat"
                                value={nomorSurat}
                                onChange={(e) => setNomorSurat(e.target.value)}
                                required
                            />
                            <Form.Text className="text-muted">
                                Jika nomor surat lebih dari satu, pisahkan dengan tanda koma. Contoh: 'xxx/xxx/xxx,xxx/xxx/xxx'
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Tanggal Surat</Form.Label>
                            <Form.Control
                                type="date"
                                value={tglSurat}
                                onChange={(e) => setTglSurat(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Pilih File Dokumen</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleFileChange}
                                accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                                required
                            />
                            <Form.Text className="text-muted">
                                Format file yang diperbolehkan: DOC, DOCX, atau PDF
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseUploadModal}>
                            Batal
                        </Button>
                        <Button variant="primary" type="submit">
                            <FaPenAlt /> Buat Surat
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </main >

    )
}

export default AdminRekomendasiPajak